import { RemoteMongoClient } from 'mongodb-stitch-browser-sdk';
import client from './client';

const mongoClient = client.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas');

export default mongoClient;
